export default "__VITE_ASSET__gbBsAlxZ__"